import type { ReactNode } from 'react';
import { Typography } from './Typography';
import styles from './Badge.module.css';
export function Badge({ children }: { children: ReactNode }) {
  return (
    <span className={styles.badge}>
      <Typography as="span" variant="caption" tone="inherit">
        {children}
      </Typography>
    </span>
  );
}
